<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-900">
    <div class="w-full max-w-md p-8 space-y-6 bg-gray-800 rounded-lg shadow-md">
      <h2 class="text-3xl font-bold text-center text-gray-100">Login</h2>
      <form @submit.prevent="handleLogin" class="space-y-6">
        <div>
          <label for="email" class="block text-sm font-medium text-gray-300">Username or Email</label>
          <input
            v-model="data"
            type="text"
            id="username"
            placeholder="Username or Email"
            required
            class="w-full px-4 py-2 mt-1 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-200"
          />
        </div>
        <div>
          <label for="password" class="block text-sm font-medium text-gray-300">Password</label>
          <input
            v-model="password"
            type="password"
            id="password"
            placeholder="••••••••"
            required
            class="w-full px-4 py-2 mt-1 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-200"
          />
        </div>
        <button
          type="submit"
          class="w-full px-4 py-2 text-lg font-semibold text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Login
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { IconsUI } from '@/utils/IconsUI';
import EventBus from '@/utils/EventBus';

export default {
  name: 'LoginPage',
  emits: [],
  props: {
    icons: { type: IconsUI, required: true },
  },
  data() {
    return {
      data: '',
      password: '',
      remember: false,
    };
  },
  methods: {
    handleLogin() {
      console.log('Logging in...');
      EventBus.emit('loginClicked', {
        data: this.data,
        password: this.password,
      });
    }
  },
}

</script>
